<div class="dialogContent calcHeight content">
  <irb-settings-dialog-banner
    [accordian]="accordion"
    [showUnsavedChangesWarning]="showUnsavedChangesWarning"
    [isModified]="isModified"
    [validationErrorTemplates]="validationErrorTemplates"
  (save)="save()">Portfolios</irb-settings-dialog-banner>
  @if (globalSettings) {
    <div class="body">
      <mat-accordion #accordion="matAccordion" [multi]="true">
        @if (globalSettings && ENABLE_SETTINGS_HIST) {
          <mat-expansion-panel [expanded]="false" (opened)="iss.updateExpansionState('HISTORY','opened')" (closed)="iss.updateExpansionState('HISTORY','closed')">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Settings History
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <irb-settings-history tabName="Portfolios"></irb-settings-history>
            </ng-template>
          </mat-expansion-panel>
        }
        @if (globalSettings) {
          <mat-expansion-panel id="GAINS_RESTRICTIONS" [expanded]="iss.getDefaultExpansionState('GAINS_RESTRICTIONS')" (opened)="iss.updateExpansionState('GAINS_RESTRICTIONS','opened')" (closed)="iss.updateExpansionState('GAINS_RESTRICTIONS','closed')">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Gains Management
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="block" style="display: flex; flex-direction: row; gap: 10px; border-bottom: 1px solid #CECECE;">
              @if (isEditGainThresholdFeatureFlagEnabled) {
                <div class="bold" style="width: 180px">Gains Threshold</div>
              }
              @if (isEditGainThresholdFeatureFlagEnabled) {
                <div class="block">
                  <div class="block">Set a gains threshold for all future portfolios.</div>
                  <div class="block" style="max-width: 655px;"><irb-expando-link text="How does a gains threshold work in iRebal?">
                    <div class="block">Set a capital gains threshold to limit annual taxable gains for a portfolio.</div>
                    <div class="block">After generating potential order(s) for a rebalance, iRebal will net the estimated potential gains or losses with the start-of-day year to date realized gain and loss value. If the result exceeds the gains threshold set for the portfolio, iRebal will refuse the order and notify you.</div>
                    <div class="">Note: For automated rebalances and scheduled rebalances, iRebal will use the start-of-day realized gain or loss value of the previous business day.</div>
                  </irb-expando-link></div>
                  <div class="block" style="display: flex; flex-direction: row; gap: 10px">
                    <div>
                      <div class="hblock bold">Select a gains threshold type</div>
                      <div>
                        <p-radioButton [disabled]="!isadmin" name="gtt" inputId="setportf1"
                        [value]="false" [(ngModel)]="gainsThresholdIsCustom" (onClick)="onGainsThresholdIsCustomChange()"></p-radioButton>
                        <label for="setportf1">No threshold</label>
                        <p-radioButton [disabled]="!isadmin" name="gtt"  inputId="setportf2"
                        [value]="true" [(ngModel)]="gainsThresholdIsCustom" (onClick)="onGainsThresholdIsCustomChange()"></p-radioButton>
                        <label for="setportf2">Set custom</label>
                      </div>
                    </div>
                    @if (gainsThresholdIsCustom) {
                      <div>
                        <div class="hblock bold">Gains Threshold Amount</div>
                        <irb-number-text-box #gainsThresholdAmtInput [disabled]="!isadmin"
                          [(value)]="gainsThresholdAmt"
                          (valueChange)="onGainsThreshholdAmtChange()"
                          places="0"
                          [min]="1"
                          [max]="9999999"
                          [isCurrency]="true"
                          [isRequired]="gainsThresholdIsCustom"
                          invalidMessage="Please enter whole numbers only"
                        invalidRangeMessage="Please enter a value between $1 and $9,999,999" width="100px"></irb-number-text-box>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
            <div style="display: flex; flex-direction: row; gap: 10px">
              <div class="bold" style="width: 180px">Gains Restrictions</div>
              <div>
                <div  class="block">
                  <div class="block">Set up capital gains restrictions for all future portfolios.</div>
                  <div class="block" style="max-width: 655px;"><irb-expando-link text="How do capital gains restrictions work in iRebal?">
                    <div class="block"><strong>No restrictions:</strong> iRebal will rebalance portfolios according to model and portfolio settings. Generated trades may include capital gains.</div>
                    <div class="block"><strong>Avoid short-term gains:</strong> iRebal will avoid short-term gains when rebalancing portfolios according to model and portfolio settings. As a result, portfolios may be out of tolerance from their model.</div>
                    <div class=""><strong>Avoid all gains:</strong> iRebal will avoid all capital gains when rebalancing portfolios according to model and portfolio settings. As a result, portfolios may be further out of tolerance from their model.</div>
                  </irb-expando-link></div>
                  <div class="hblock bold">Capital Gains Restrictions</div>
                  <div>
                    <irb-dropdown-filter #gainsControlSetting
                      [disabled]="!isadmin"
                      [(value)]="portfolioCapitalGainSetting"
                      (search)="setPortfolioCapitalGains($event)"
                      size="30" hoverPanelWidth="280"
                      (valueChange)="onGainRestrictionChange()"
                    ></irb-dropdown-filter>
                  </div>
                </div>
                <div>
                  <div class="block">You can apply your selected restriction to all current portfolios now or manage capital gains restrictions in individual portfolios.</div>
                  <button [disabled]="!isadmin"  class="btn-medium-secondary applyToAllPortfolio left" (click)="onApplyToAllPortfolios()" title="Apply to All Portfolios">Apply Restriction to All Portfolios</button>
                  <a class="goToPortfoliosLink left" (click)="onClickGoToPortfolios()">Go to Portfolios</a>
                  <div class="clear"></div>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        }
        @if (globalSettings) {
          <mat-expansion-panel id="CUSTOM_CATEGORIES" [expanded]="iss.getDefaultExpansionState('CUSTOM_CATEGORIES')" (opened)="iss.updateExpansionState('CUSTOM_CATEGORIES','opened')" (closed)="iss.updateExpansionState('CUSTOM_CATEGORIES','closed')" #customLabelsPanel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                Custom Labels
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="block">Name a new column and then create customized portfolio labels to organize your portfolios. Filter your portfolios and include them in rebalances.</div>
            <div class="block" style="display: flex; flex-direction: row; gap: 10px;">
              <div class="bold" style="width: 130px">Column Name</div>
              <div>
                <div class="hblock"><irb-validation-text-box #columnNameInput id="portfolioCustLabelAbbr"
                  max="25"
                  [(value)]="globalSettings.portfolioCustLabelAbbr"
                  width="278px"
                  [disabled]="!isadmin"
                  (valueChange)="onInputChange()"
                  [isRequired]="isPortfolioCustLabelAbbrRequired"
                ></irb-validation-text-box></div>
                <div style="color: #999999; font-size: 10px;">25 characters max</div>
              </div>
            </div>
            <div class="block bottomBorder" style="display: flex; flex-direction: row; gap: 10px;">
              <div class="bold" style="width: 130px">Column Description</div>
              <div>
                <textarea rows="2" maxlength="50" id="w3review" (keyup)="onInputChange()" [(ngModel)]="globalSettings.portfolioCustLabelDesc" cols="36" [disabled]="!isadmin"></textarea>
                <div style="color: #999999; font-size: 10px;">(Optional) 50 characters max</div>
              </div>
            </div>
            <div class="block">
              <strong>Label Values</strong>
              <span class="right"><a (click)="export()">Export Labels</a>&nbsp;<fa-icon id="exportLink" [icon]="faDownload" class="irb-blue clickable" tooltip tooltipTitle="Export Labels" (click)="export()"></fa-icon></span>
            </div>
            <div class="block">
              <button class="btn-medium-secondary" label="Add Labels" (click)="toggleCategoryMenuItem()" [disabled]="showCategoryMenuItem">Add Labels</button>
            </div>
            @if (showCategoryMenuItem) {
              <div class="block irb-lite-green-background" style="padding: 10px; width: 440px;">
                <div class="block" style="display: flex; flex-direction: row; gap: 10px;">
                  <div class="bold" style="width: 120px">Label Name</div>
                  <div>
                    <div class="hblock"><irb-validation-text-box #labelNameInput id="newPortfolioCustLabelAbbr"
                      max="25"
                      [(value)]="newPortfolioCustLabelAbbr"
                      width="278px"
                      [disabled]="!isadmin"
                      (valueChange)="onNewPortfolioCustLabelAbbrChange()"
                      [isRequired]="isNewPortfolioCustLabelAbbrRequired"
                      [regExp]="labelNamesRegExp"
                      invalidMessage="The value entered is not valid."
                      (keyup.enter)="addCategoryMenuItem()"
                    ></irb-validation-text-box></div>
                    <div style="color: #999999; font-size: 10px;">25 characters max</div>
                  </div>
                </div>
                <div class="block bottomBorder" style="display: flex; flex-direction: row; gap: 10px;">
                  <div class="bold" style="width: 120px">Label Description</div>
                  <div>
                    <div class="hblock"><irb-validation-text-box #labelDescriptionInput id="newPortfolioCustLabelDesc"
                      max="50"
                      [(value)]="newPortfolioCustLabelDesc"
                      width="278px"
                      [disabled]="!isadmin"
                      (valueChange)="validateCategoryMenuItem()"
                      invalidMessage="The value entered is not valid."
                      (keyup.enter)="addCategoryMenuItem()"
                    ></irb-validation-text-box></div>
                    <div style="color: #999999; font-size: 10px;">(Optional) 50 characters max</div>
                  </div>
                </div>
                <div style="text-align: right;">
                  <button class="btn-medium-secondary" id="addButton" label="Close" (click)="toggleCategoryMenuItem()">Close</button>
                  <button class="btn-medium-secondary btn-spacer" id="addButton" label="Add"
                    [disabled]="!isadmin"
                  (click)="addCategoryMenuItem()">Add</button>
                </div>
              </div>
            }
            @if (gridOptions && !isUiTest) {
              <div class="block">
                <irb-inventory-grid
                  [style.width] = "'100%'"
                  [style.height] = "gridHeight"
                  [showSideBar] = "false"
                  [gridOptions] = "gridOptions"
                  [footerContent] = "footerContent"
                  [frameworkComponents] = 'frameworkComponents'
                  (cellValueChanged) = "onGridChange($event)"
                (gridReady) = "onGridReady($event)"></irb-inventory-grid>
              </div>
            }
            <div>Assign your labels to portfolios. <a (click)="onClickGoToPortfolios()">Go to Portfolios</a></div>
          </mat-expansion-panel>
        }
      </mat-accordion>
    </div>
  }
</div>

<ng-template #columnNameValidationErrorTemplate>
  The 'Column Name' field cannot be empty. Enter a <a (click)="focusColumnNameInput()">Column Name</a>.
</ng-template>
<ng-template #labelNameValidationErrorTemplate>
  The 'Label Name' field cannot be empty. Enter a <a (click)="focusLabelNameInput()">Label Name</a>.
</ng-template>
<ng-template #labelNameExistsValidationErrorTemplate>
  '{{newPortfolioCustLabelAbbr}}' is already in use. Enter a different <a (click)="focusLabelNameInput()">Label Name</a>.
</ng-template>
<ng-template #labelNameInvalidCharValidationErrorTemplate>
  '{{newPortfolioCustLabelAbbr}}' may not contain a '^'. Enter a different <a (click)="focusLabelNameInput()">Label Name</a>.
</ng-template>
<ng-template #labelNameInvalidPrefixValidationErrorTemplate>
  '{{newPortfolioCustLabelAbbr}}' may not be prefixed with +, -, = or &#64;. Enter a different <a (click)="focusLabelNameInput()">Label Name</a>.
</ng-template>
<ng-template #labelDescInvalidPrefixValidationErrorTemplate>
  '{{newPortfolioCustLabelDesc}}' may not be prefixed with +, -, = or &#64;. Enter a different <a (click)="focusLabelDescriptionInput()">Label Description</a>.
</ng-template>
<ng-template #labelNameGridValidationErrorTemplate>
  One or more entries in Custom Labels are invalid.
</ng-template>
<ng-template #gainsThresholdAmtValidationErrorTemplate>
  The 'Gains Threshold Amount' field cannot be empty or invalid.
</ng-template>
